/* 🤖 this file was generated by script */
export const wiconWflow = {
  name: 'wflow',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M12.75 8.34l3.05-3.78s.58.67 1.24 1.55a3.58 3.58 0 01-.1 4.29l-1.28 1.58-2.8 3.46L9.9 11.9m2.84-3.55L9.93 4.88 7.17 8.34m5.58 0L9.9 11.89m-5.64.1l2.8 3.45L9.9 11.9m-5.64.1L2.98 10.4c-1.17-1.46-.64-3.4 0-4.3l1.13-1.54 3.06 3.78m-2.9 3.64l2.9-3.64"/></svg>`,
};
